// extracted by mini-css-extract-plugin
module.exports = {"OfferingsTabs":"OfferingsTabs_OfferingsTabs__2fmVB","OfferingsTab":"OfferingsTabs_OfferingsTab__sbXtW","Active":"OfferingsTabs_Active__1YrlC"};